import React from 'react'

const ProfileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.5 7.5C8.88125 7.5 10 6.38125 10 5C10 3.61875 8.88125 2.5 7.5 2.5C6.11875 2.5 5 3.61875 5 5C5 6.38125 6.11875 7.5 7.5 7.5ZM7.5 8.75C5.83125 8.75 2.5 9.5875 2.5 11.25V12.5H12.5V11.25C12.5 9.5875 9.16875 8.75 7.5 8.75Z'
      fill='currentcolor'
    />
  </svg>
)

export default ProfileIcon
